<!--<div class="wallboardViewSlide" mid="{{moduleKey}}" [ngClass]="{'rocketBackground':racingState.Theme == 'Rocket Race', 'motocrossBackground':racingState.Theme =='Motocross', 'swimBackground':racingState.Theme =='Swim Meet', 'horseBackground':racingState.Theme =='Horse Derby'}">
    <div class="wallboardViewHeader" [ngClass]="{'rocketHeader':racingState.Theme == 'Rocket Race', 'motocrossHeader':racingState.Theme =='Motocross', 'swimHeader':racingState.Theme =='Swim Meet', 'horseHeader':racingState.Theme == 'Horse Derby'}">-->
<div class="wallboardViewSlide" [attr.mid]="moduleKey" [ngStyle]="{ 'background-image': getRacingImage(1) } ">
    <div class="wallboardViewHeader" [ngStyle]="{ 'background-image': getRacingImage(2) }">
        <div class="wallboardViewTitle">
            <div class="wvBannerTitle txtOverflow">{{racingState?.BannerTitle}}</div>
            <div class="wvMetricDisplayName txtOverflow m-auto" style="font-size:2vw; width:80%">{{racingState?.MetricDisplayName}}</div>

            <div class="wvRaceTargetBoard" *ngIf="racingState?.Positioning == 'Target'" [ngStyle]="{ 'background-image': getRacingImage(3) }">
                <div class="wvTargetTitle" cvLocalizedText langSection="Wallboard_Management" langKey="Finish_Line">Finish Line</div>
                <div class="wvRaceTarget">{{racingData?.[0].targetDisplayValue}}</div>
            </div>
        </div>
    </div>

    <div class="raceArea">
        <div *ngIf="racingData?.length > 0">
            <div id="lane{{$index}}" class="racingLane" *ngFor="let item of racingData | orderBy: racingState.UseRankSort == true ? '' : 'groupName'; let $index = index">
                <div class="racingTrail" [attr.mid]="moduleKey">
                    <span class="teamName hidden">
                        <span class="teamNameValue txtOverflow">{{item.groupName}}</span>
                    </span>

                    <span class="wallboardViewData hidden">
                        <span class="wallboardViewDataValue">{{item.metricData.MetricDisplayValue}}</span>
                    </span>
                </div>

                <!-- Rockets -->
                <div class="racingRocket racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme == 'Rocket Race'"></div>
                <!-- Motocross -->
                <div class="racingBike racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Motocross'"></div>
                <!-- Swimmers -->
                <div class="racingSwimmer racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Swim Meet'"></div>
                <!-- Horses -->
                <div class="racingHorse racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Horse Derby'"></div>
                <!-- Boats -->
                <div class="racingBoat racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Boat Racing'"></div>
                <!-- Dragsters -->
                <div class="racingDrag racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Drag Racing'"></div>
                <!-- Formula One -->
                <div class="racingF1 racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Formula One Racing'"></div>
                <!-- Jets -->
                <div class="racingJet racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Jet Racing'"></div>
                <!-- Monster Trucks -->
                <div class="racingMonster racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Truck Racing'"></div>
                <!-- ATV -->
                <div class="racingAtv racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='ATV Racing'"></div>
                <!-- Raptors -->
                <div class="racingRaptor racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Raptor Racing'"></div>
                <!-- Snails -->
                <div class="racingSnail racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Snail Racing'"></div>
                <!-- Snowmobiles -->
                <div class="racingSnowmobile racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Snowmobile Racing'"></div>
                <!-- Street Racers -->
                <div class="racingStreet racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Street Racing'"></div>
                <!-- Tortoise and Hares -->
                <div class="racingTortHare racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Tortoise And Hare Racing'"></div>
                <!-- UFO -->
                <div class="racingUfo racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='UFO Racing'"></div>
                <!-- Train -->
                <div class="racingTrains racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Train Racing'"></div>
                <!-- christmas tree -->
                <div class="racingChristmasTrees racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Christmas Tree Racing'"></div>
                <!-- cupid -->
                <div class="racingCupid racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Cupid Racing'"></div>
                <!-- easeter bunny -->
                <div class="racingEasterBunny racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Easter Bunny Racing'"></div>
                <!-- elderly -->
                <div class="racingElderly racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Elderly Racing'"></div>
                <!-- fish -->
                <div class="racingFish racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Fish Racing'"></div>
                <!-- robots -->
                <div class="racingRobots racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Robot Racing'"></div>
                <!-- sleigh ride -->
                <div class="racingSleighs racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Sleigh Ride Racing'"></div>
                <!-- st patricks day -->
                <div class="racingStPatrick racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='St Patricks Day Racing'"></div>
                <!-- super -->
                <div class="racingSuper racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Super Racing'"></div>
                <!-- turkey -->
                <div class="racingTurkey racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Turkey Racing'"></div>
                <!-- zombie -->
                <div class="racingZombie racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Zombie Racing'"></div>
                <!-- st patricks day 2-->
                <div class="racingStPatrick2 racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='St Patricks Day Racing 2'"></div>
                <!-- Thanksgiving Racing 1-->
                <div class="racingThanksgiving1 racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Thanksgiving Racing 1'"></div>
                <!-- Thanksgiving Racing 2-->
                <div class="racingThanksgiving2 racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Thanksgiving Racing 2'"></div>
                <!-- Easter Racing 2-->
                <div class="racingEaster2 racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Easter Racing 2'"></div>
                <!-- Valentine Racing 1-->
                <div class="racingValentine1 racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Valentine Racing 1'"></div>
                <!-- Candy Land Racing-->
                <div class="racingCandyLand racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Candy Land Racing'"></div>
                <!-- Christmas Carol Racing-->
                <div class="racingChristmasCarol racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Christmas Carol Racing'"></div>
                <!-- Halloween Racing 1-->
                <div class="racingHalloween1 racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Halloween Racing 1'"></div>
                <!-- Jungle Racing 1 -->
                <div class="racingJungle1 racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Jungle Racing 1'"></div>
                <!-- Jungle Racing 2 -->
                <div class="racingJungle2 racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Jungle Racing 2'"></div>
                <!-- Mask Racing -->
                <div class="racingMask racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Mask Racing'"></div>
                <!-- Plant Racing -->
                <div class="racingPlant racer" [ngClass]="getClasses($index)" *ngIf="racingState.Theme =='Plant Racing'"></div>
            </div>
        </div>

        <div class="noRaceData" *ngIf="racingData?.length == 0">No Data Available</div>
    </div>
</div>
